/** Build YYYY-MM values for the next `count` months starting from today. */
export function buildMonthRange(count = 12) {
	const opts = [];
	const d = new Date();
	for (let i = 0; i < count; i++) {
		const x = new Date(d.getFullYear(), d.getMonth() + i, 1);
		opts.push(`${x.getFullYear()}-${String(x.getMonth() + 1).padStart(2, '0')}`);
	}
	return opts;
}

export function buildMonthOptions(count = 12) {
	const opts = [];
	const d = new Date();
	for (let i = 0; i < count; i++) {
		const x = new Date(d.getFullYear(), d.getMonth() + i, 1);
		opts.push({
			value: `${x.getFullYear()}-${String(x.getMonth() + 1).padStart(2, '0')}`,
			label: x.toLocaleDateString('en-US', { month: 'long', year: 'numeric' }),
			shortLabel: x.toLocaleDateString('en-US', { month: 'short', year: 'numeric' }),
		});
	}
	return opts;
}

export function monthLabelFromValue(value) {
	if (!value) return '';
	const [y, m] = value.split('-').map(Number);
	if (!y || !m) return value;
	return new Date(y, m - 1, 1).toLocaleDateString('en-US', { month: 'long', year: 'numeric' });
}
